import "./weeklyCalendar.scss";
import { useState } from "react";
import {
    format,
    startOfWeek,
    addDays,
    isSameDay,
    lastDayOfWeek,
    addWeeks,
    subWeeks
} from "date-fns";


/**
 * Follow this tutorial https://medium.com/@moodydev/create-a-custom-calendar-in-react-3df1bfd0b728
 * and customised by TTNT
 * date-fns doc: https://date-fns.org/v2.21.1/docs
 */


const WeeklyCalendar = ({ LeftHeader, children }) => {
    const [currentMonth, setCurrentMonth] = useState(new Date());
    const [selectedDate, setSelectedDate] = useState(new Date());

    const changeWeekHandle = (btnType) => {
        //console.log("current week", currentWeek);
        if (btnType === "prev") {
            //console.log(subWeeks(currentMonth, 1));
            setCurrentMonth(subWeeks(currentMonth, 1));
        }
        if (btnType === "next") {
            //console.log(addWeeks(currentMonth, 1));
            setCurrentMonth(addWeeks(currentMonth, 1));
        }
    };

    const onDateClickHandle = (day, dayStr) => {
        setSelectedDate(day);
        // showDetailsHandle(dayStr);
    };

    const renderHeader = () => {
        const dateFormat = "MMMM yyyy";
        // console.log("selected day", selectedDate);
        return (
            <div className="header">
                <div className="col col-start">
                    <div style={{ display: 'flex', columnGap: 16, alignItems: 'center' }}>
                        <div style={{ display: 'flex', columnGap: 16 }}>
                            <div onClick={() => changeWeekHandle("prev")}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M10.0404 3.95952C10.431 4.35004 10.431 4.98321 10.0404 5.37373L7.41421 7.99996L10.0404 10.6262C10.431 11.0167 10.431 11.6499 10.0404 12.0404C9.64992 12.4309 9.01675 12.4309 8.62623 12.0404L5.29289 8.70707C4.90237 8.31654 4.90237 7.68338 5.29289 7.29285L8.62623 3.95952C9.01675 3.56899 9.64992 3.56899 10.0404 3.95952Z"
                                        fill="#5F5F5F"
                                    />
                                </svg>

                            </div>
                            <div onClick={() => changeWeekHandle("next")}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={16}
                                    height={16}
                                    viewBox="0 0 16 16"
                                    fill="none"
                                >
                                    <path
                                        fillRule="evenodd"
                                        clipRule="evenodd"
                                        d="M5.95952 3.95952C6.35004 3.56899 6.98321 3.56899 7.37373 3.95952L10.7071 7.29285C11.0976 7.68338 11.0976 8.31654 10.7071 8.70707L7.37373 12.0404C6.98321 12.4309 6.35004 12.4309 5.95952 12.0404C5.56899 11.6499 5.56899 11.0167 5.95952 10.6262L8.58575 7.99996L5.95952 5.37373C5.56899 4.98321 5.56899 4.35004 5.95952 3.95952Z"
                                        fill="#5F5F5F"
                                    />
                                </svg>
                            </div>
                        </div>
                        <span style={{ fontSize:  10, fontWeight: 700, color: '#2a2a2a'}}>{format(currentMonth, dateFormat)}</span>
                    </div>
                </div>
                {<LeftHeader />}
            </div>
        );
    };
    const renderCells = () => {
        const startDate = startOfWeek(currentMonth, { weekStartsOn: 1 });
        const endDate = lastDayOfWeek(currentMonth, { weekStartsOn: 1 });
        const dateFormat = "d";
        const rows = [];
        let days = [];
        let day = startDate;
        let formattedDate = "";
        while (day <= endDate) {
            for (let i = 0; i < 7; i++) {
                formattedDate = format(day, dateFormat);
                const cloneDay = day;
                days.push(
                    <div
                        className={`col cell ${isSameDay(day, new Date())
                            ? "today"
                            : isSameDay(day, selectedDate)
                                ? "selected"
                                : ""
                            }`}
                        key={day}
                        onClick={() => {
                            const dayStr = format(cloneDay, "ccc dd MMM yy");
                            onDateClickHandle(cloneDay, dayStr);
                        }}
                    >
                        <div className="date-cell">
                            <p className="day">{format(day, 'EEE')}</p>
                            <p className="number">{formattedDate}</p>
                        </div>
                    </div>
                );
                day = addDays(day, 1);
            }

            rows.push(
                <div className="row" key={day}>
                    {days}
                </div>
            );
            days = [];
        }
        return <div className="body">{rows}</div>;
    };

    return (
        <div className="calendar">
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {renderHeader()}
            </div>
            {renderCells()}
            {children}
        </div>
    );
}


export default WeeklyCalendar;